export const HERO_IMG = "/hero_fam.png";

export const CATALOG_URL = "https://www.sportswearcollection.com/?site=DYYVLUZHWU";

export const CONTACT = {
  phone: "(513) 260-0899",
  email: "BriarsUnlimited@gmail.com",
  location: "Middletown, New Jersey",
  hours: "Mon – Fri: 9AM – 5PM",
};

export const BRANDS = ["Gildan", "Comfort Colors", "Bella+Canvas", "Hanes"];

export const CATEGORIES = [
  { key: "businesses", label: "Businesses", img: "/work5.png" },
  { key: "schools", label: "Schools", img: "/work4.png" },
  { key: "teams", label: "Teams", img: "/work9.png" },
  { key: "events", label: "Events", img: "/work1.png" },
  { key: "gifts", label: "Custom Gifts", img: "/work2.png" },
  { key: "more", label: "More", img: "/work10.png" },
];

export const GALLERY = [
  { img: "/work5.png", label: "South Brooklyn Terminal" },
  { img: "/work1.png", label: "The Weatherlys · Event" },
  { img: "/work9.png", label: "Caseys Soccer" },
  { img: "/work7.png", label: "Hill-N-Dale Equestrian" },
  { img: "/work2.png", label: "Difference Maker" },
  { img: "/work10.png", label: "SYD Denim Jacket" },
  { img: "/work4.png", label: "Saint Mary School" },
  { img: "/work6.png", label: "Beach Club · 60th" },
  { img: "/work14.png", label: "Charlie's Favorite" },
  { img: "/work3.png", label: "Briars Unlimited Koozie" },
  { img: "/work8.png", label: "Millersville Equestrian" },
  { img: "/work12.png", label: "Desert Skull Tumbler" },
  { img: "/work13.png", label: "Lina · Chenille Pouch" },
  { img: "/work15.png", label: "Dance Mom" },
  { img: "/work11.png", label: "Wyatt · Personalized" },
  { img: "/work16.png", label: "Chicks & Slicks" },
  { img: "/work17.png", label: "Redlight Kings" },
];

export const SHOP_LINKS = ["T-Shirts", "Hoodies", "Hats", "Drinkware", "Bags", "Accessories"];

export const SERVICE_LIST = [
  { title: "Custom Apparel", desc: "Tees, hoodies, jerseys and more for any group or occasion." },
  { title: "Promotional Products", desc: "Drinkware, bags, and gifts branded exactly how you want." },
  { title: "Design Services", desc: "Our team turns your idea into a print-ready mockup." },
  { title: "Bulk & Team Orders", desc: "Rosters, numbers, and names handled with care." },
];
